import Toast from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin(nuxt => {
    nuxt.vueApp.use(Toast, { rtl: true, position: 'top-left' });
});
